import { Box, SxProps, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { Input } from 'components/Inputs';
import { useState } from 'react';
import { formatToDateTime } from 'utils/datetime';

const container: SxProps = {
  backgroundColor: 'customGrey.light',
  //   width: '100%',
  p: 2
};

const buttonsContainer: SxProps = {
  display: 'flex',
  gap: 1,
  mt: 2
};

const buttonContainer: SxProps = {
  p: 0
};

const inputContainer: SxProps = {
  backgroundColor: 'white'
};

type Props = {
  content: string;
  isInitialEditing: boolean;
  createdBy?: string | null;
  createdAt?: string;
  createNote?: (content: string) => void;
  updateNote: (id: string, content: string) => void;
  onCancel?: () => void;
  deleteNote: (id: string) => void;
  id?: string;
  readOnly?: boolean;
};

export const CandidateNoteEditor: React.FC<Props> = ({
  content,
  isInitialEditing,
  createNote,
  updateNote,
  createdBy,
  createdAt,
  onCancel,
  deleteNote,
  id,
  readOnly = false
}) => {
  const [value, setValue] = useState(content);
  const [isEditing, setIsEditing] = useState(isInitialEditing);

  // eslint-disable-next-line
  const handleEdit = async () => {
    setIsEditing(true);
  };

  const handleConfirm = async () => {
    setIsEditing(false);

    if (id) {
      await updateNote(id, value);
      return;
    }

    await createNote?.(value);
  };

  const handleCancel = () => {
    onCancel?.();
  };

  const handleDelete = async () => {
    if (id) {
      await deleteNote(id);
    }
  };

  return (
    <Box sx={container}>
      {isEditing ? (
        <Input
          label="Add comment"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={inputContainer}
          placeholder="Leave comment  about the analysis and your thoughts"
          rows={4}
          multiline
        />
      ) : (
        <Box>
          {createdAt && (
            <Typography variant="caption">
              Added {formatToDateTime(createdAt)} by {createdBy || 'Unknown'}
            </Typography>
          )}
          <Typography mt={1}>{value}</Typography>
        </Box>
      )}

      <Box sx={buttonsContainer}>
        {isEditing ? (
          <>
            <Button
              onClick={handleConfirm}
              sx={buttonContainer}
              disabled={!value}
              variant="tertiary"
            >
              Confirm
            </Button>
            <Button
              variant="tertiary"
              state="destructive"
              onClick={handleCancel}
              sx={buttonContainer}
            >
              Cancel
            </Button>
          </>
        ) : (
          !readOnly && (
            <>
              {/* <Button
              onClick={handleEdit}
              sx={{ ...buttonContainer, p: 0, minHeight: 0, minWidth: 0 }}
            >
              Edit
            </Button> */}
              <Button
                variant="tertiary"
                state="destructive"
                onClick={handleDelete}
                sx={buttonContainer}
              >
                Delete
              </Button>
            </>
          )
        )}
      </Box>
    </Box>
  );
};
